import { render, staticRenderFns } from "./EDKeywordsForm.vue?vue&type=template&id=94912360&"
import script from "./EDKeywordsForm.vue?vue&type=script&lang=js&"
export * from "./EDKeywordsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94912360')) {
      api.createRecord('94912360', component.options)
    } else {
      api.reload('94912360', component.options)
    }
    module.hot.accept("./EDKeywordsForm.vue?vue&type=template&id=94912360&", function () {
      api.rerender('94912360', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/components/EDKeywordsForm.vue"
export default component.exports